import { DomainRule, IsInFlowService } from '../types';

export interface AtLeastOneMessageRequiredRuleDto {
  isInFlowService: IsInFlowService;
}

export const AtLeastOneMessageRequiredRuleKey = 'atLeastOneMessageRequired';

/**
 * We require at least one message to be selected. A message is the popover, notice, or other
 * HTML content that will be displayed on-site when a trigger is hit.
 *
 * @param triggerSettings
 * @returns 'fail', with an error message, if no messages are chosen. 'pass' if any are set.
 */
export const AtLeastOneMessageRequiredRule = (dto: AtLeastOneMessageRequiredRuleDto): DomainRule => {
  const isAnyInFlow = dto.isInFlowService.isAnyMessageInFlow();

  if (!isAnyInFlow) {
    return {
      result: 'fail',
      ruleKey: AtLeastOneMessageRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
